"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

var _immutable = require("immutable");

var _default = function _default(source) {
  var currentOwnerIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var ownerIds = [];

  if (_immutable.List.isList(source)) {
    ownerIds = source.toJS();
  } else {
    source.find('[data-at-mention]').each(function (i, el) {
      var ownerId = parseInt((0, _jquery.default)(el).attr('data-owner-id'), 10);

      if (!ownerIds.includes(ownerId)) {
        return ownerIds.push(ownerId);
      }

      return ownerIds;
    });
  }

  var ownerUpdates = [];

  if (_immutable.List.isList(currentOwnerIds)) {
    currentOwnerIds = currentOwnerIds.toJS();
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = ownerIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var ownerId = _step.value;

      if (!currentOwnerIds.includes(ownerId)) {
        ownerUpdates.push({
          objectType: 'OWNER',
          id: ownerId,
          mutationType: 'ADD'
        });
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = currentOwnerIds[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var currentOwnerId = _step2.value;

      if (!ownerIds.includes(currentOwnerId)) {
        ownerUpdates.push({
          objectType: 'OWNER',
          id: currentOwnerId,
          mutationType: 'REMOVE'
        });
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return ownerUpdates;
};

exports.default = _default;
module.exports = exports.default;